import { useListShipmentsQuery } from "@/__generated__/graphql";
import { useBranding } from "@/providers/branding-provider";

interface UseShipmentsOptions {
  count?: number;
  skip?: boolean;
}

export function useShipments(options: UseShipmentsOptions = {}) {
  const branding = useBranding();
  const { count = 10, skip = false } = options;

  const { data, loading, error, fetchMore, refetch } = useListShipmentsQuery({
    variables: {
      merchantId: branding.merchantId,
      count,
    },
    skip,
  });

  const shipments = data?.returns?.results ?? [];
  const nextToken = data?.returns?.nextToken;
  const hasMore = !!nextToken;

  const handleLoadMore = () => {
    if (nextToken) {
      fetchMore({
        variables: {
          nextToken,
        },
      });
    }
  };

  return {
    shipments,
    loading,
    error,
    hasMore,
    nextToken,
    handleLoadMore,
    refetch,
  };
}
